{
	"note": {
		"ranked": "Type each {{word}}. The total, discards and ranks follow. Type a rank to settle a tie: it stays as typed.",
		"match": "Type each {{word}}. The score and the winner follow. Pick the winner by hand when the target judge decides."
	},
	"word": {
		"end": "End",
		"series": "Series",
		"round": "Round",
		"race": "Race",
		"game": "Game",
		"run": "Run",
		"moto": "Moto",
		"pass": "Pass",
		"short": {
			"end": "E{{n}}",
			"series": "S{{n}}",
			"round": "R{{n}}",
			"race": "Race {{n}}",
			"game": "G{{n}}",
			"run": "Run {{n}}",
			"moto": "M{{n}}",
			"pass": "P{{n}}"
		}
	},
	"round": {
		"long": "{{word}} {{n}}"
	},
	"columns": {
		"total": "Total",
		"setPoints": "Set points",
		"toPar": "To par",
		"thru": "Thru",
		"shootOff": "S-O",
		"shootOffLong": "Shoot-off arrows",
		"closest": "Closest",
		"winner": "Winner",
		"bonus": "Bonus",
		"bonusLong": "Bonus pins: 10 a game won, 5 a tie (Masters round robin)"
	},
	"tally": {
		"tens": "10+X",
		"x_count": "X",
		"inner_tens": "X",
		"final_sprint_place": "Final sprint",
		"shots_fired": "Shots"
	},
	"tallyLong": {
		"tens": "10s, X included",
		"x_count": "Xs (inner 10s)",
		"inner_tens": "Inner tens",
		"final_sprint_place": "Place in the points race's final sprint (breaks a tie)",
		"shots_fired": "Shots fired"
	},
	"cell": {
		"discarded": "Discarded: not in the total",
		"double": "Medal race: counts double, never discarded",
		"decider": "Decider: breaks a tie, not in the total",
		"placePoints": "Place typed: worth {{points}} points",
		"total": "Worked out from the rounds",
		"fromBowlers": "The sum of the bowlers' games. Change it in the Bowlers panel."
	},
	"bonus": {
		"label": "Bonus",
		"hint": "W (10), T (5) or L (0) for each game of the round robin"
	},
	"bowlers": {
		"title": "Bowlers",
		"bowler": "Bowler",
		"total": "Total",
		"average": "Avg",
		"edit": "Enter bowlers' games",
		"none": "No bowler's games yet. The team's games can be typed in the row, or per bowler here.",
		"rosterLoading": "Loading the team…",
		"rosterError": "The team could not be loaded.",
		"saved": "Bowlers saved. The team's games follow.",
		"conflict": "Someone saved this team first.",
		"teamTotal": "Team {{total}}",
		"outOfStep": "The team's games in the row are not the sum of its bowlers' games.",
		"useTheirs": "Use the bowlers' games"
	},
	"rank": {
		"typed": "Typed",
		"typedLong": "Typed rank: kept as typed. Clear it to rank by the score again.",
		"hint": "Type a rank to settle a tie (a shoot-off, a play-off)."
	},
	"winner": {
		"pick": "Winner",
		"picked": "Winner (picked)",
		"pickHint": "Make this side the winner, whatever the score says.",
		"clearHint": "Let the score decide the winner again."
	},
	"parts": {
		"par": "Par",
		"outIn": "Out {{out}} · In {{inn}}",
		"showAll": {
			"arrow": "Show all arrows",
			"shot": "Show all shots",
			"hole": "Show all holes",
			"frame": "Show all frames"
		},
		"toggle": {
			"arrow": "Arrows",
			"shot": "Shots",
			"hole": "Holes",
			"frame": "Frames"
		},
		"toggleFor": "{{what}}, {{name}}",
		"word": {
			"arrow": "Arrow",
			"shot": "Shot",
			"hole": "Hole",
			"frame": "Frame"
		},
		"of": {
			"arrow": "Arrows of end {{n}}",
			"shot": "Shots of series {{n}}",
			"hole": "Holes of round {{n}}",
			"frame": "Frames of game {{n}}"
		},
		"fromTsr": "Frames come from TSR's lane scoring and are shown only."
	},
	"aria": {
		"round": "{{word}} {{n}}, {{name}}",
		"tally": "{{code}}, {{name}}",
		"shootOff": "Shoot-off, {{name}}",
		"closest": "Closest to the centre, {{name}}",
		"rank": "Rank, {{name}}",
		"part": "{{what}} {{n}} of round {{round}}, {{name}}",
		"bonus": "Bonus of game {{n}}, {{name}}",
		"bowlerGame": "Game {{n}}, {{name}}"
	},
	"parse": {
		"format": "Type a number, a mark (OCS) or both (21 OCS)",
		"precision": "Too many decimal places for this sport",
		"range": "Outside the allowed range",
		"irm": "Not a mark this sheet knows",
		"rank": "A rank is a whole number from 1",
		"part": "Type a number, X (10) or M (miss)",
		"game": "A game is a whole number from 0 to {{max}}",
		"bonus": "Type W (10), T (5) or L (0)"
	},
	"settings": {
		"label": "Meet settings",
		"rounds": "{{word}}s",
		"open": "open",
		"discards": "Discards",
		"step": "{{n}} from {{from}}",
		"none": "none",
		"medalRace": "Medal race",
		"medalRaceLong": "The last race is the medal race (double points, never discarded)",
		"yes": "yes",
		"no": "no",
		"scoring": "Scoring",
		"scoringDefault": "The discipline's default",
		"scoringValue": {
			"SET": "Set points (recurve)",
			"CUMULATIVE": "Cumulative (compound)"
		},
		"scoringBowling": {
			"SET": "Games won (best of)",
			"CUMULATIVE": "Total pins (stepladder)"
		},
		"par": "Par",
		"parLong": "Par per hole, in order (4 4 3 5 …)",
		"parValue": "{{total}} over {{holes}} holes",
		"edit": "Change",
		"save": "Save",
		"saved": "Meet settings saved",
		"stale": "Someone changed this meet. Reload it and try again.",
		"lockedHint": "Settings are fixed once results are in.",
		"error": {
			"rounds": "Rounds: a whole number from 1 to 40, or blank",
			"discards": "Discards: a whole number from 0 to 10, or blank",
			"par": "Par: up to 36 holes, each 1 to 9"
		}
	}
}
